"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combinePatterns = (...patterns) => patterns.join('');
